import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes, faTrash, faUndo } from "@fortawesome/free-solid-svg-icons";
import { NumericTextBox } from "@progress/kendo-react-inputs";

export interface PayRateConfirmationModalProps {
    showModal: boolean;
    handleYes: any;
    handleNo: any;
    subBillRateId?: string;
    payRate?: any;
    holidayPayRate?: any;
    billRates?: any;
    holidayBillRates?: any;
    handleChange?: any;
}

export interface PayRateConfirmationModalState {
    showModal: boolean;
}

export class PayRateConfirmationModal extends React.Component<PayRateConfirmationModalProps, PayRateConfirmationModalState> {
    constructor(props) {
        super(props);
        this.state = { showModal: false };
    }

    render() {
        return (
            <div className="">
                {this.props.showModal && (
                    <div className="containerDialog">
                        <div className="containerDialog-animation">
                            <div className="col-10 col-sm-7 col-xl-4 shadow containerDialoginside">
                                <div className="row blue-accordion">
                                    <div className="col-12  pt-2 pb-2 fontFifteen">
                                        Pay Rate
                                        <span className="float-right" onClick={this.props.handleNo}>
                                            <FontAwesomeIcon icon={faTimes} className="mr-1" />
                                        </span>
                                    </div>
                                </div>

                                <div className="row ml-0 mr-0 mt-3">
                                    <div className="col-12 col-sm-12 col-lg-6 mt-sm-3 mt-1 cal-icon-color">
                                        <label className="mb-2 text-dark font-weight-bold required">Pay Rate</label>
                                        <NumericTextBox
                                            className="form-control"
                                            placeholder="Enter Pay Rate"
                                            value={isNaN(this.props.payRate) ? 0 : this.props.payRate}
                                            format="c2"
                                            min={0}
                                            max={99999}
                                            name="payRate"
                                            onChange={(e) => this.props.handleChange(e)}
                                        />
                                    </div>

                                    <div className="col-12 col-sm-12 col-lg-6 mt-sm-3 mt-1 cal-icon-color text-box-disbaled">
                                        <label className="mb-2 text-dark font-weight-bold required">Holiday Pay Rate</label>
                                        <NumericTextBox
                                            className="form-control"
                                            placeholder="Enter Holiday Pay Rate"
                                            value={isNaN(this.props.holidayPayRate) ? 0 : this.props.holidayPayRate}
                                            format="c2"
                                            min={0}
                                            max={99999}
                                            name="holidayPayRate"
                                            onChange={(e) => this.props.handleChange(e)}
                                        />
                                    </div>
                                </div>

                                <div className="row mx-0 ">
                                <div className="col-12 col-sm-12 col-lg-6 mt-sm-3 mt-1 cal-icon-color">
                                        <label className="mb-2 text-dark font-weight-bold required">Bill Rate</label>
                                        <NumericTextBox
                                            className="form-control"
                                            disabled={true}
                                            placeholder="Enter Bill Rate"
                                            value={isNaN(this.props.billRates) ? 0 : this.props.billRates}
                                            format="c2"
                                            min={0}
                                            max={99999}
                                            name="billRates"
                                        />
                                    </div>

                                    <div className="col-12 col-sm-12 col-lg-6 mt-sm-3 mt-1 cal-icon-color text-box-disbaled">
                                        <label className="mb-2 text-dark font-weight-bold required">Holiday Bill Rate</label>
                                        <NumericTextBox
                                            className="form-control"
                                            disabled={true}
                                            placeholder="Enter Holiday Bill Rate"
                                            value={isNaN(this.props.holidayBillRates) ? 0 : this.props.holidayBillRates}
                                            format="c2"
                                            min={0}
                                            max={99999}
                                            name="holidayBillRates"
                                        />
                                    </div>
                                </div>
                                <div className="row ml-0 mr-0">
                                    <div className="col-12 mt-4 mb-4 text-center font-regular">
                                        <button
                                            disabled={!(this.props.payRate && this.props.holidayPayRate && this.props.payRate > 0 && this.props.holidayPayRate > 0 && this.props.payRate != null && this.props.holidayPayRate != null)}
                                            type="button"
                                            onClick={this.props.handleYes}
                                            className="btn button button-bg mr-3 shadow mb-2 mb-xl-0 px-4">
                                            <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                                            Ok
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default PayRateConfirmationModal;